import './RerequisitionCallout.scss';

import { Notification } from '@myome/ui';

import { ROUTES } from '@constants/routes';

interface RerequisitionCalloutProps {
  individualId?: string;
}

export function RerequisitionCallout({ individualId }: RerequisitionCalloutProps) {
  const destination = individualId
    ? `${ROUTES.ORDER}/${ROUTES.ORDER_NEW_TEST}?individual=${encodeURIComponent(individualId)}`
    : `${ROUTES.ORDER}/${ROUTES.ORDER_NEW_TEST}`;

  return (
    <Notification
      variant='success'
      title="You're eligible to order a new test"
      action={{ label: 'Start your order', to: destination }}
      className='rerequisition-callout'
    >
      <p>Start your next order now.</p>
    </Notification>
  );
}
